import { useEffect, useRef, useState } from 'react';
import { Timer } from 'easytimer.js';

const timer = new Timer();

// eslint-disable-next-line import/prefer-default-export
export const useTimer = ({ timeLeft, isCompleted, isPaused }) => {
  const [tick, setTick] = useState('');
  const sessionStartSecondsRef = useRef(null);
  const savedSecondsRef = useRef(0);

  useEffect(() => {
    if (!Number.isFinite(timeLeft)) {
      return undefined;
    }

    const handleSecondsUpdated = () => {
      let str = timer.getTimeValues().toString();
      if (timer.getTimeValues().hours === 0) {
        str = str.slice(3, str.length);
      }
      setTick(str);
    };

    timer.addEventListener('secondsUpdated', handleSecondsUpdated);
    timer.start({
      precision: 'seconds',
      startValues: { seconds: timeLeft },
      countdown: true
    });

    if (sessionStartSecondsRef.current === null) {
      sessionStartSecondsRef.current = timer.getTotalTimeValues().seconds;
    }

    return () => {
      timer.removeEventListener('secondsUpdated', handleSecondsUpdated);
    };
  }, [timeLeft]);

  useEffect(() => {
    if (isCompleted) {
      timer.stop();
    } else if (isPaused) {
      timer.pause();
    } else if (timer.isPaused()) {
      timer.start();
    }
  }, [isPaused, isCompleted]);

  const getSecondsElapsed = () => {
    if (sessionStartSecondsRef.current === null) {
      return 0;
    }

    return Math.max(0, sessionStartSecondsRef.current - timer.getTotalTimeValues().seconds);
  };

  const getSecondsElapsedSinceLastSave = () => Math.max(
    0,
    getSecondsElapsed() - savedSecondsRef.current
  );

  const markSecondsElapsedSaved = (seconds) => {
    savedSecondsRef.current += seconds;
  };

  return [
    isCompleted ? '00:00' : tick,
    getSecondsElapsedSinceLastSave,
    markSecondsElapsedSaved
  ];
};
